import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Home as HomeIcon } from "lucide-react";
import { WhatsAppIcon, waUrl } from "../components/WhatsAppButton";
import { hotel } from "../mock";

const NotFound = () => (
  <div
    data-testid="not-found-page"
    className="relative min-h-screen flex items-center justify-center bg-[#221e18] text-white px-6 overflow-hidden"
  >
    <div
      className="absolute inset-0 bg-cover bg-center opacity-20"
      style={{ backgroundImage: "url(/images/safranbolu/sb-pano-1.webp)" }}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#221e18] via-[#221e18]/70 to-[#221e18]/85" />

    <div className="relative z-10 max-w-xl text-center">
      <p className="eyebrow text-[#d9b877] mb-6">Safranbolu Çelebi Otel</p>
      <h1 className="font-display text-[7rem] md:text-[10rem] leading-none font-500 text-white/95">
        404
      </h1>
      <div className="gold-divider my-6" />
      <h2 className="font-display text-2xl md:text-3xl font-500 mb-4">
        Aradığınız sayfa bulunamadı
      </h2>
      <p className="text-white/60 text-[15px] leading-relaxed mb-10">
        Bu sayfa taşınmış ya da hiç var olmamış olabilir. Sizi konforlu
        odalarımıza ve Safranbolu'nun büyüsüne geri götürelim.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <Link
          to="/"
          data-testid="notfound-home-btn"
          className="btn-gold px-7 py-3.5 rounded-sm flex items-center gap-2"
        >
          <HomeIcon size={16} /> Ana Sayfaya Dön
        </Link>
        <a
          href={waUrl(`${hotel.whatsappIntro} Müsaitlik ve fiyat bilgisi rica ediyorum.`)}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-outline-gold !text-white !border-white/40 hover:!bg-white/10 px-7 py-3.5 rounded-sm flex items-center gap-2"
        >
          <WhatsAppIcon size={16} /> Rezervasyon
        </a>
      </div>
      <Link
        to="/iletisim"
        className="inline-flex items-center gap-2 text-white/50 hover:text-[#d9b877] transition-colors text-[13px] mt-8"
      >
        <ArrowLeft size={14} /> İletişim sayfası
      </Link>
    </div>
  </div>
);

export default NotFound;
